// import {AppUser} from "../data/types";
//
// export function isSuper(user: AppUser | null) {
//     return (user && user?.roles.indexOf("SUPER") > -1)
// }

import { toTitleCase } from "./stringHelpers";

export function getFirstName(username: String) {
  if (!username) return '';
  return toTitleCase(username.split(' ')[0]);
}
